import RequiredInput from '../elements/required-input';

const CommunicationDetails = () => (
  <div>
    <RequiredInput
      controlId='email'
      label='Email address'
      model='.email'
      placeholder='Email'
      type='email'
    />
    <RequiredInput
      controlId='mobile'
      label='Mobile number'
      model='.mobile'
      placeholder='Mobile'
      type='tel'
    />
  </div>
);

export default CommunicationDetails;
